import React, { useEffect, useRef } from 'react';
import { useTheme } from '../../hooks/useTheme';
import {
  useCursorTrailEnabled,
  useCursorTrailEngine,
} from './useCursorTrailEngine';

const CursorTrail = () => {
  const canvasRef = useRef(null);
  const { isDarkMode } = useTheme();
  const isEnabled = useCursorTrailEnabled();
  useCursorTrailEngine(canvasRef, isEnabled, isDarkMode);

  useEffect(() => {
    if (!isEnabled) return undefined;

    document.documentElement.classList.add('cursor-trail-active');
    return () => {
      document.documentElement.classList.remove('cursor-trail-active');
    };
  }, [isEnabled]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div className="cursor-trail-layer" aria-hidden="true">
      <canvas ref={canvasRef} className="cursor-trail-canvas" />
    </div>
  );
};

export default CursorTrail;
